import React, { useMemo } from 'react';
import { selectActiveOrgIntegrations } from 'shared/store/auth-slice';
import { HubspotOrgIntegrationData } from 'types/hubspot';
import { OrgIntegrationService } from 'sb-lib/types';
import { Icon } from 'shared/components/Icon';
import { useSelector } from 'react-redux';
import { AppState } from 'shared/store/reducers';
import './style.less';

export const ConnectedCallSocials: React.FC = () => {
  const { detailTask, sourceType } = useSelector((state: AppState) => state.outbound);

  const { contact, sourceId } = detailTask ?? {};
  const externalContactId =
    detailTask && 'externalContactId' in detailTask
      ? detailTask.externalContactId ?? sourceId
      : sourceId;

  const orgIntegrations = useSelector(selectActiveOrgIntegrations);

  const hsPortalId = useMemo(() => {
    return (orgIntegrations.find(o => o.service === OrgIntegrationService.hubspot)
      ?.data as HubspotOrgIntegrationData)?.portalId;
  }, [orgIntegrations]);

  const query = encodeURI(
    `${contact?.name ?? ''} ${contact?.company?.name ?? ''}`.trim(),
  );

  const googleLink = `https://www.google.com/search?q=${query}`;
  const linkedInLink = `https://www.linkedin.com/search/results/people?keywords=${query}`;

  if (!contact) return <></>;

  return (
    <div className="ConnectedCallSocials">
      {hsPortalId && sourceType?.includes('hubspot_') && (
        <a
          href={`https://app.hubspot.com/contacts/${hsPortalId}/${externalContactId}`}
          rel="noreferrer"
          className="ConnectedCallSocials__item"
          target="_blank"
        >
          <Icon width={14} height={14} icon="hubspot" />
        </a>
      )}
      <a
        href={linkedInLink}
        rel="noreferrer"
        className="ConnectedCallSocials__item"
        target="_blank"
      >
        <Icon width={14} height={14} icon="linkedinFilled" />
      </a>
      <a
        href={googleLink}
        className="ConnectedCallSocials__item"
        target="_blank"
        rel="noreferrer"
      >
        <Icon width={14} height={14} icon="google" />
      </a>
    </div>
  );
};
